import React from 'react';

const InviteModal = ({ isOpen, message, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
      <div className="bg-white rounded-lg w-full max-w-sm p-6">
        <p className="text-center mb-6">{message}</p>
        <button
          onClick={onClose}
          className="w-full py-2 px-4 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors font-medium"
        >
          확인
        </button>
      </div>
    </div>
  );
};

export default InviteModal;